import { render, staticRenderFns } from "./JobViewJobCustomerCard.vue?vue&type=template&id=958a8782&"
import script from "./JobViewJobCustomerCard.vue?vue&type=script&lang=js&"
export * from "./JobViewJobCustomerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports